import adActions from 'actions/adActions';
import { queryString, } from 'utils/window';
import { BaseStore, } from 'stores/baseStore';
import { AD_FORMATS, } from 'config/adsConfig';
import navbarActions from 'actions/navbarActions';
import { getSingleElementByClass, } from 'utils/dom';
import pageDataObject from 'application/pageDataObject';
import scrollingEventsProvider from 'providers/scrollingEventsProvider';


const { adsDebugSizes, } = queryString;

class NavbarStore extends BaseStore {

  constructor(options = {}){
    super(options);
    this.merge({
      isStickyEnabled: false,
      hasTitle: false,
    });
  }

  routeAction(action){
    let ACTIONS = navbarActions.TYPES;
    switch (action.type) {
      case ACTIONS.REACHED_COVER_SOCIAL_COMPONENT:
        return this.repositionShareComponent(action.scrollingEventObject);
      case ACTIONS.REACHED_POST_TITLE:
        return this.repositionTitle(action.scrollingEventObject);
      case adActions.TYPES.SLOT_RENDERED:
        const { adId, event: e, } = action;
        adsDebugSizes && this.info(adId, e);
        if (adId === AD_FORMATS.Top && e.size) {
          this.repositionMobileHeader(e.size[1]);
        }
        return this;
      default:
        return this;
    }
  }

  get isStickyEnabled(){ return this.state.isStickyEnabled; }
  set isStickyEnabled(bool){ this.state.isStickyEnabled = bool; }
  get hasTitle(){ return this.state.hasTitle; }
  set hasTitle(bool){ this.state.hasTitle = bool; }

  repositionMobileHeader(topHeight){
    return this.emitChange({ topHeight, });
  }

  repositionShareComponent(isInViewport){
    const eventConfig = {
      isInViewport: isInViewport,
      triggerFlag: "isStickyEnabled",
      triggerEvent: "emitChange",
      customCondition: window.scrollY > getSingleElementByClass('share-component').offsetTop,
      store: this,
    };
    scrollingEventsProvider.triggerEventOnce(eventConfig);
    return this;
  }

  repositionTitle(isInViewport){
    const eventConfig = {
      isInViewport,
      triggerFlag: "hasTitle",
      triggerEvent: "emitChange",
      customCondition: window.scrollY > getSingleElementByClass('post-article__post-title').offsetTop,
      store: this,
    };
    scrollingEventsProvider.triggerEventOnce(eventConfig);
    return this;
  }

}

const navbarStore = NavbarStore.create();

export default navbarStore;


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/stores/navbarStore.js